import { ApolloQueryResult, gql, QueryResult, useLazyQuery, useQuery } from '@apollo/client';

import { client } from '../../../apollo/ApolloConfig';
import { getPolices } from '../../../utils/gqlPolicesUtil';

export const GET_JOB_TITLE_BASED_ON_ACADEMIC_PROGRAM = gql`
  query GetJobTitleBasedOnAcademicProgram($academicProgramId: NonEmptyString!) {
    getJobTitleBasedOnAcademicProgram(academicProgramId: $academicProgramId) {
      id
      name
      match
    }
  }
`;

export interface IGetJobTitleBasedOnAcademicProgramParams {
  academicProgramId: string;
}

export interface IJobTitle {
  id: string;
  name: string;
  match: number;
}

export interface IGetJobTitleBasedOnAcademicProgramResponse {
  getJobTitleBasedOnAcademicProgram: IJobTitle[];
}

type UseLazyGetJobTitleBasedOnAcademicProgramReturn = ReturnType<
  typeof useLazyQuery<IGetJobTitleBasedOnAcademicProgramResponse, IGetJobTitleBasedOnAcademicProgramParams>
>;

export const useLazyGetJobTitleBasedOnAcademicProgram = (
  fromCache?: boolean,
): UseLazyGetJobTitleBasedOnAcademicProgramReturn =>
  useLazyQuery<IGetJobTitleBasedOnAcademicProgramResponse, IGetJobTitleBasedOnAcademicProgramParams>(
    GET_JOB_TITLE_BASED_ON_ACADEMIC_PROGRAM,
    { ...getPolices(fromCache) },
  );

export const getJobTitleBasedOnAcademicProgramRefetch = (
  academicProgramId: string,
): Promise<ApolloQueryResult<IGetJobTitleBasedOnAcademicProgramResponse>> =>
  client.query<IGetJobTitleBasedOnAcademicProgramResponse, IGetJobTitleBasedOnAcademicProgramParams>({
    query: GET_JOB_TITLE_BASED_ON_ACADEMIC_PROGRAM,
    variables: { academicProgramId },
    fetchPolicy: 'network-only',
    context: { queryDeduplication: false },
  });

export const useQueryGetJobTitleBasedOnAcademicProgram = (
  academicProgramId: string,
  fromCache?: boolean,
): QueryResult<IGetJobTitleBasedOnAcademicProgramResponse, IGetJobTitleBasedOnAcademicProgramParams> =>
  useQuery<IGetJobTitleBasedOnAcademicProgramResponse, IGetJobTitleBasedOnAcademicProgramParams>(
    GET_JOB_TITLE_BASED_ON_ACADEMIC_PROGRAM,
    {
      ...getPolices(fromCache),
      variables: {
        academicProgramId,
      },
    },
  );
